module.exports = __webpack_public_path__ + "static/media/codepen.2164c928.svg";